import { currentLocale } from "../localization/t.js";

const urls = {
	development: `http://${typeof document === "undefined" ? "localhost" : document.location.hostname}:3001`,
	production: "https://4p1.4m3ric4.com"
};

export const API_URL = urls[process.env.NODE_ENV];

const API_TOKEN = "totktneettneeknteoeetteokentntkn";

function request(endpoint, parameters = {}, options = {}) {
	const queryString = new URLSearchParams(parameters).toString();

	return fetch(`${API_URL}/api/${endpoint}?${queryString}`, {
		headers: {
			"X-Token": API_TOKEN,
			"Accept-Language": currentLocale()
		},
		...options
	});
}

async function json(endpoint, parameters, options) {
	const res = await request(endpoint, parameters, options);

	if (!res.ok) {
		throw new Error(`API error: ${res.status} ${res.statusText}`);
	}

	return res.json();
}

export function article(location) {
	return json("article", location);
}

export function classifieds(location) {
	return json("classifieds", location);
}

export function directions(waypoints, overview, exclude) {
	return json("directions", { waypoints, overview, exclude });
}

export function locality(location) {
	return json("locality", location);
}

export function poi(query, location) {
	return json("poi", { query, ...location });
}

export function radios(location) {
	return json("radios", location);
}

export function weather(location) {
	return json("weather", location);
}

export function photos(location) {
	return json("photos", location);
}

export function report(locality, photo, token) {
	return json("report", { locality, photo, token });
}

export function food(location) {
	return json("food", location);
}

export function news(locality) {
	return json("news", { locality });
}

export function route(profile) {
	return json("route", { profile });
}

export function feedback(message) {
	return json("feedback", { message });
}

export function origin() {
	return json("origin");
}

export function turn() {
	return json("turn");
}

export function cairns(location) {
	return json("cairn", location);
}

export function buildCairn(size, seed) {
	return json(
		"cairn",
		{ size, seed },
		{
			method: "POST"
		}
	);
}

export function placeCairn(size, name, seed, note, latitude, longitude) {
	return json(
		"cairn",
		{ size, name, seed, note, latitude, longitude },
		{
			method: "PUT"
		}
	);
}

export function fetchCairnBySlug(slug) {
	return json("cairn", { slug });
}

export function fetchCairnById(id) {
	return json("cairn", { id });
}

export function fetchCannedRoute() {
	return json("route");
}

export function storeValue(session, key, value) {
	return fetch(`${API_URL}/api/storage?key=${key}`, {
		method: "POST",
		headers: {
			"x-token": API_TOKEN,
			"x-session": session
		},
		body: value
	});
}

export function getStoredValue(session, key) {
	return fetch(`${API_URL}/api/storage?key=${key}`, {
		headers: {
			"x-token": API_TOKEN,
			"x-session": session
		}
	});
}

export async function dumpStoredValues(session) {
	const res = await fetch(`${API_URL}/api/storage`, {
		headers: {
			"x-token": API_TOKEN,
			"x-session": session
		}
	});

	if (!res.ok) {
		throw new Error(`API error: ${res.status} ${res.statusText}`);
	}

	return res.json();
}

export async function createJournalEntry(dayNumber, locality, vehicleColor, vehicleName, weather, memories) {
	const res = await fetch(`${API_URL}/api/journal`, {
		method: "POST",
		headers: {
			"x-token": API_TOKEN
		},
		body: JSON.stringify({ dayNumber, locality, vehicleColor, vehicleName, weather, memories })
	});

	return res.json();
}
